var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvothermColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 228.7 72",
    style: {
      enableBackground: "new 0 0 228.7 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000106853590245648514960000016584345692462430865_);fill:#CE0E2D;}\n\t.st1{clip-path:url(#SVGID_00000106853590245648514960000016584345692462430865_);fill:#010101;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0,
    y: 0,
    width: 228.7,
    height: 72
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047048767514831775390000002566062655291359638_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#CE0E2D"
    },
    d: "M100.7,21 c6,0,11.2,3.5,13.6,8.7v-27C110.1,1,105.5,0,100.7,0C85.4,0,72.4,9.5,67.1,22.9H73L76.6,36h0.1l3.6-13.1h7.6l-7.2,21.9H70.6 l-5.1-16.3c-0.5,2.4-0.8,4.9-0.8,7.5c0,19.9,16.1,36,36,36c4.8,0,9.4-1,13.6-2.7v-27c-2.4,5.1-7.6,8.7-13.6,8.7 c-8.3,0-15-6.7-15-15C85.6,27.7,92.4,21,100.7,21"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    d: "M96.6,36 c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3C98.5,40.3,96.6,38.4,96.6,36 M100.9,47.5 c6.4,0,11.5-5.2,11.5-11.5c0-6.4-5.2-11.5-11.5-11.5c-6.4,0-11.5,5.2-11.5,11.5C89.3,42.4,94.5,47.5,100.9,47.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    d: "M25.6,36 c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3C27.5,40.3,25.6,38.4,25.6,36 M29.8,47.5 c6.4,0,11.5-5.2,11.5-11.5c0-6.4-5.2-11.5-11.5-11.5c-6.4,0-11.5,5.2-11.5,11.5C18.3,42.4,23.5,47.5,29.8,47.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "43.7,25.1  51.5,25.1 58.4,36.5 58.5,25.1 64.8,25.1 64.8,47 57.3,47 50.1,35.1 50.1,47 43.7,47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "67,25.1  75,25.1 78.6,38.2 78.6,38.2 82.3,25.1 89.9,25.1 82.7,47 73.9,47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "130.9,30.2  125.7,30.2 125.7,47 118.3,47 118.3,30.2 113.1,30.2 113.1,25.1 130.9,25.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "144.7,25.1  152.1,25.1 152.1,47 144.7,47 144.7,39.1 140.4,39.1 140.4,47 133,47 133,25.1 140.4,25.1 140.4,32.6 144.7,32.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "154.7,25.1  168.2,25.1 168.2,29 162,29 162,33.4 167.7,33.4 167.7,38 162,38 162,43 168.3,43 168.3,47 154.7,47  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    d: "M177.5,30h1.4 c0.7,0,2.2,0.3,2.2,2.3c0,2.2-1.7,2.4-2.4,2.4h-1.3V30z M170.4,47h7.4v-7.4h1L182,47h7.7l-5-10.2v-0.1c2.8-0.8,3.9-2.4,3.9-5.8 c0-4.2-2.9-5.8-7.5-5.8h-10.7V47z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    points: "194.9,25.1  205.9,25.1 208.4,35.7 211,25.1 221.9,25.1 226,47 218,47 215.2,33.8 211.3,47 205.1,47 201.4,33.8 198.5,47 190.9,47  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    d: "M15.3,38 c-0.7,1.4-2.1,2.3-3.8,2.3c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3c1.6,0,3.1,0.9,3.8,2.3v-8.9c-1.2-0.4-2.5-0.6-3.8-0.6 C5.2,24.5,0,29.6,0,36c0,6.4,5.2,11.5,11.5,11.5c1.3,0,2.6-0.2,3.8-0.7V38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#010101"
    },
    d: "M228.1,26.1 c0,1-0.7,1.7-1.6,1.7v0c-0.9,0-1.6-0.7-1.6-1.7c0-1,0.7-1.7,1.6-1.7C227.3,24.3,228.1,25,228.1,26.1 M226.1,26.3h0.2l0.6,1h0.6 l-0.6-1.1c0.3,0,0.6-0.2,0.6-0.6c0-0.6-0.4-0.7-1-0.7h-0.9v2.4h0.5V26.3z M226.1,25.9v-0.6h0.4c0.2,0,0.5,0,0.5,0.3 c0,0.3-0.1,0.3-0.4,0.3H226.1z M228.7,26.1c0-1.4-1.1-2.3-2.3-2.3c-1.2,0-2.3,0.8-2.3,2.3c0,1.4,1.1,2.3,2.3,2.3 C227.6,28.3,228.7,27.5,228.7,26.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047048767514831775390000002566062655291359638_)",
      fill: "#CE0E2D"
    },
    d: "M143.7,77.7L139.5,93 l-10.4-0.1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvothermColor);
export default __webpack_public_path__ + "static/media/Convotherm_Color.4d428a9c63591c19c32ce7a9667de8c8.svg";
export { ForwardRef as ReactComponent };